<template>
  <div class="carousel">
    <el-carousel
      :interval="3000"
      arrow="never"
      indicator-position="outside"
      autoplay
      v-model="currentImage"
    >
      <el-carousel-item v-for="(item, index) in carouselItems" :key="item.name">
        <img :src="item.image" :alt="item.name" class="carousel-image" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "DataCategorisationCarousel",
  data() {
    return {
      currentImage: 0,
      carouselItems: [
        { image: require('@/assets/images/Chatbanner(ReplaceMTFBanner).svg'), name: 'Item 1' },
        { image: require('@/assets/images/ExpertViewBannerforExpertBuzz(1).svg'), name: 'Item 2' },
      ],
    };
  },
};
</script>

<style lang="scss">
.carousel {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 120px; // 100px image + 20px space for dots
  overflow: hidden;

  .carousel-image {
    width: 100%;
    height: 90px;
    object-fit: contain;
    display: block;
    border-radius: 20px !important;
  }

  .el-carousel__container {
    padding-bottom: 0 !important;
    margin-bottom: 10px !important;
    height: 115px !important;
  }

  .el-carousel__indicators--outside {
    position: absolute !important;
    bottom: 2px !important;
    left: 50%;
    transform: translateX(-50%);
  }

  .el-carousel__indicator--horizontal {
    width: auto;

    button {
      width: 8px !important;
      height: 8px !important;
      border-radius: 50% !important;
      background-color: #bbb !important;
      transition: background-color 0.3s ease;
    }

    &.is-active button {
      background-color: #2D2E8D !important;
    }
  }
}

@media (max-width: 768px) {
  .carousel {
    width: 100% !important;
  }
}
</style>
